import {
  PLAN_TYPE_DESTINATION,
  PLAN_TYPE_SOURCE,
} from '../CreateRecommend/RecommendSourceDestination/constants';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {RECOMMENDATION_SUBTYPE_TO_SERVER} from '../../../constants/SolutionType';
import {UpsertOvrecommendVariables} from '../../../schema-types/UpsertOvrecommend';
import validateUUID from '../../../utils/validateUUID';
import {
  getPotContactId,
  updateRecommendPotsVariables,
  updateRecsVarsProps,
  getIsMinor,
} from './helpers';
import {getFeeServerFromFormik} from '../CreateRecommend/DAInitialFees';

const getAnnuityVariables = async ({
  accountId,
  goalId,
  ovrecommendId,
  values,
  contacts = [],
}: updateRecsVarsProps): Promise<UpsertOvrecommendVariables> => {
  const {annuity, contact, urgency, urgencyReason} = values;
  const isMinor = getIsMinor(contact, contacts);

  return {
    action: OVRecommendActionEnum.SET_UP_NEW,
    ovrecommendId: validateUUID(ovrecommendId),
    accountId: validateUUID(accountId),
    goalId: validateUUID(goalId),
    isNewPlanRequired: true,
    contactId: getPotContactId(contact, isMinor),
    urgency,
    urgencyReason,
    solutionType: RECOMMENDATION_SUBTYPE_TO_SERVER.PRODUCT_BASED,
    note: annuity?.notes,
  };
};

export const generateAnnuityOVRPots = async ({
  accountId,
  goalId,
  ovrecommendId,
  values,
  generateRecommendationPots,
  recommendDetails,
  reviewId,
  contacts = [],
}: updateRecommendPotsVariables) => {
  const {annuity, contact} = values;

  await generateRecommendationPots({
    variables: {
      accountId: validateUUID(accountId)!,
      ovrecommendId: validateUUID(ovrecommendId)!,
      args: [
        {
          planType: PLAN_TYPE_DESTINATION,
          isDummy: true,
          reviewId: validateUUID(reviewId),
          originalOvrId: validateUUID(ovrecommendId),
          contactId: values.contact ? validateUUID(values.contact) : null,
          annuityType: annuity?.annuityType,
          incomeFrequency: annuity?.incomeFrequency,
          guaranteedPeriod: annuity?.guaranteePeriod,
          spouseAnnuityPercent: annuity?.spouseAnnuityPercent,
          rateType: annuity?.rateType,
          indexLinked: annuity?.indexLinked,
          ltcCapitalProtected: annuity?.longTermCareCapitalProtected,
          protectedPercentage: annuity?.ltcProtectedPercent,
          initialFee: annuity?.initialFee,
          notes: annuity?.notes,
          paymentType: annuity?.paymentType,
        },
      ],
    },
  });

  const sourceId = annuity?.sourceId;
  if (!sourceId) {
    return;
  }
  const source = values.transfer?.transferSources[sourceId];

  await generateRecommendationPots({
    variables: {
      accountId: validateUUID(accountId)!,
      ovrecommendId: validateUUID(ovrecommendId)!,
      args: [
        {
          planType: PLAN_TYPE_SOURCE,
          potId: validateUUID(sourceId)!,
          isDummy: false,
          reviewId: validateUUID(reviewId)!,
          originalOvrId: validateUUID(ovrecommendId)!,
          contactId: values.contact ? validateUUID(values.contact) : null,
          inSpecie: false,
          planNumber: source?.accountNumber,
          productProviderId: source?.planProvider,
          productNameId: source?.planType,
          initialFee: values.isSppDa ? undefined : source?.initialFee,
          legacyInitialFee: getFeeServerFromFormik(
            values.isSppDa,
            source?.legacyInitialFee
          ),
          isAuthorityHeld: undefined,
          isDataGather: undefined,
          full: source?.full || false,
          currentDirectValue: undefined,
          singleClientAmount: source?.singleClientAmount,
        },
      ],
    },
  });
};

export default getAnnuityVariables;
